// 出荷の正規化応答(CarryOuts + related.Lots/Materials/Users/Groups)を、従来のネスト形
// (carryOutRow: 出荷→Lots→Materials/User、出荷→User)へ復元する共通ハイドレータ。
// 結合は nestHydrator の宣言的エンジン(生成メタデータのエッジキー)で行う。
// related.Lots はサーバー側で alive のロットのみ(従来 include の where deleted_at:null を踏襲)。
// User の結び付けは api 側 Sequelize の関連付け(同名 belongsTo の後勝ち)と同じ規則で
// 出荷・ロットとも created_by_user_id を使う。
// ロット配下の User は従来 include が required:false だったため、related に無い場合は null を保つ
// (carryOutRowSchama の Lots[].User も nullable)。
// Lots / Materials の並びはサーバーのバケット順(id 昇順)をそのまま保つ。
import { carryOutRow, NormalizedCarryOutResponse } from "../../schema/console/carry_out";
import { hasManyOf, requiredUserOf, userOrNullOf } from "./nestHydrator";
import { usersWithGroupOf } from "./relatedLookup";

export function hydrateCarryOuts(normalized: NormalizedCarryOutResponse): carryOutRow[] {
  const users = usersWithGroupOf(normalized.related.Users, normalized.related.Groups);
  const lotsOf = hasManyOf("CarryOut.Lots", normalized.related.Lots);
  const materialsOf = hasManyOf("Lot.Materials", normalized.related.Materials);
  const carryOutUserOf = requiredUserOf("CarryOut.created_by_user_id", users, "出荷", "登録者");
  const lotUserOf = userOrNullOf("Lot.created_by_user_id", users);
  return normalized.CarryOuts.map((carryOut): carryOutRow => ({
    ...carryOut,
    Lots: lotsOf(carryOut.id).map((lot) => ({
      ...lot,
      Materials: materialsOf(lot.id),
      User: lotUserOf(lot),
    })),
    User: carryOutUserOf(carryOut),
  }));
}
